import { yupResolver } from "@hookform/resolvers/yup";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { addEventType } from "../../api/eventType";
import BackButton from "../../component/BackButton";
import Loader from "../../component/Loader";
import { FetchEventTypeDetail } from "./EventTypeSlice";
import Select from "react-select";
function AddEventType() {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  let companyOptions = [];
  const companiesStr = localStorage.getItem('companies');
  if (companiesStr) {
    try {
      const companies = JSON.parse(companiesStr);
      if (Array.isArray(companies) && companies.length > 0) {
        companyOptions = [
          ...companies.map(c => ({
            value: c.id,
            label: c.company_name
          }))
        ];
      }
    } catch (e) {
      // Optionally handle JSON parse error
      companyOptions = [];
    }
  }
  const [selectedCompany, setSelectedCompany] = useState(0);

  const schema = Yup.object({
    name: Yup.string().required("Required"),
  });

  const {
    register,
    handleSubmit,
    handleBlur,
    setValue,
    values,
    watch,
    reset,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    resolver: yupResolver(schema),
  });

  const company_id = watch("company_id");

  useEffect(() => {
    if (id) {
      setLoading(true);
      dispatch(FetchEventTypeDetail(id)).then((res) => {
        if (res?.payload?.code === 1) {
          setLoading(false);
          reset({
            name: res?.payload?.data?.event_type_details?.name,
            company_id: res?.payload?.data?.event_type_details?.company_id,
          });
          setSelectedCompany(res?.payload?.data?.event_type_details?.company_id)
        }
      });
    }
  }, [dispatch, id]);

  const onSubmit = (data) => {
    console.log(data);
    setSubmitting(true);

    const payload = {
      name: data?.name,
      company_id,
      event_type_id: id ? id : "",
    };

    addEventType(payload).then((res) => {
      setSubmitting(false);

      if (res?.code === 1) {
        navigate("/event-types", { replace: true });
        toast.success(res?.message);
      } else {
        toast.error(res?.message, {  autoClose: false,  closeButton: true});
      }
    });
  };

  if (loading) {
    return (
      <article className="col-lg-9 articleClass">
        <Loader />
      </article>
    );
  } else {
    return (
      <article className="col-lg-9 articleClass">
        <div className="article-body store-bd-gy">
          <div className="row align-items-center col-rever">
            <BackButton />

            <div className="col-sm-12 col-md-12 col-lg-12 mb-3 text-center">
              <h3>{id ? "Edit" : " New"} Event Category</h3>
            </div>
          </div>
          <div className="row mt-3">
            <div className="col-sm-12">
              <form className="form-style" onSubmit={handleSubmit(onSubmit)}>
                <div className="row">
                {Array.isArray(companyOptions) && companyOptions.length > 0 && (
                  <div className="col-sm-12 col-md-12 mb-4">
                    <div className="form-group">
                      <label className="fw-bold">Company</label>
                      {errors?.company_id && (
                        <span className="text-red ms-1">
                          {errors?.company_id?.message}
                        </span>
                      )}
                      <Select
                        className="form-control"
                        options={companyOptions}
                        isSearchable
                        name="company_id"
                        {...register("company_id")}
                        placeholder="Select a company..."
                        value={companyOptions.find(option => option.value == company_id)}
                        onChange={option => setValue('company_id', option ? Number(option.value) : null)}
                        onBlur={handleBlur}
                      />
                    </div>
                  </div>
                  )}
                  <div className="col-sm-6 col-md-6 mb-4">
                    <div className="form-group">
                      <label className="fw-bold">Event Category</label>
                      {errors?.name && (
                        <span className="text-red ms-1">
                          {errors?.name?.message}
                        </span>
                      )}
                      <div className="input-container">
                        <input
                          type="text"
                          className="form-control pl-5"
                          placeholder="Event Category"
                          name="name"
                          {...register("name")}
                        />
                        <img
                          src="assets/images/event-name.png"
                          className="input-img"
                          alt=""
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-12 text-center">
                    <button
                      type="submit"
                      className="btn btn-save"
                      disabled={submitting}
                    >
                      {submitting ? <Loader /> : "Save"}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </article>
    );
  }
}

export default AddEventType;
